import { InjectionKey, Ref } from 'vue';

/** Greenfield source field IDs that are required for sharing */
export const ProvidedGreenfieldSourceFields: InjectionKey<Ref<number[]>> =
  Symbol('ProvidedGreenfieldSourceFields');

/** Population to population sharing overrides settings */
export const ProvidedPopToPopOverrides: InjectionKey<unknown[]> = Symbol(
  'ProvidedPopToPopOverrides',
);
